import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import '../../../Assets/css/landingPage.css';
import DiamondEducation from './DiamondEducation';
import EarthMindLabButton from './EarthMindLabButton';
import ExploreDimondByShap from './ExploreDimondByShap';
import LooseDiamondPage from './LooseDiamondPage';
import OwnEngagmentRing from './OwnEngagmentRing';
import { Accordion, AccordionDetails, AccordionSummary, Breadcrumbs, Typography } from '@mui/material';
import { Col, Row, Container } from 'react-bootstrap';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

const DiamondsStaticPage = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails?.title}</title>
        <meta name="description" content={metaDetails?.description}></meta>
        <meta name="keywords" content={metaDetails?.keywords}></meta>
      </Helmet>
      <div className="dfld_diamond_Section">
        <LooseDiamondPage />
        {/* <EarthMindLabButton /> */}
        <ExploreDimondByShap />
        <OwnEngagmentRing />
        <DiamondEducation />
        <Container>
          <Row>
            <Col sm={12}>
              <div className="rcs_privacy_content rcs_mobile_menu mb-5 w-100 top_heading_metal eng_faq_title">
                <h3>FAQs for Diamonds</h3>
                <div className="rcs_faq_accordion mb-5">
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <Typography>What is the significance of the "four Cs" in diamond quality??</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>The "four Cs" stand for Cut, Clarity, Color, and Carat weight. These factors collectively determine the quality and value of a diamond.</Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                      <Typography>What's the difference between a diamond's cut, clarity, color, and carat weight?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        - Cut: This refers to how well a diamond has been shaped and faceted. A well-cut diamond will sparkle more.
                        <br />
                        - Clarity: It measures the presence of internal or external flaws or inclusions within the diamond. A higher clarity grade means fewer imperfections.
                        <br />
                        - Color: Diamond color is graded on a scale from D (colorless) to Z (light yellow or brown). The less color, the higher the grade.
                        <br />- Carat weight: This indicates the size of the diamond. Larger diamonds have a higher carat weight.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header">
                      <Typography>How can I verify the accuracy of the four C's in my diamond to ensure that the stone matches the promised quality?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>To ensure the accuracy of the four C's in your diamond and its promised quality, start by requesting a reputable certification from a recognized gemological lab like GIA or IGI, carefully reviewing the certificate's information. If in doubt, seek a second opinion from an independent appraiser.. Purchase from a trusted jeweler with a good reputation who is willing to answer your questions transparently. These steps will help ensure your diamond meets the expected quality standards.</Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4a-content" id="panel4a-header">
                      <Typography>How can I ensure the ethical sourcing of a diamond for the engagement ring?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>Look for diamonds with certifications from organizations like the Kimberley Process, which aims to prevent the trade of conflict diamonds. You can also choose diamonds from jewelers who are committed to ethical and sustainable sourcing.</Typography>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default DiamondsStaticPage;
